import { useRouter } from 'next/router';
import { memo, useEffect } from 'react';
import {
  fetchEnquiryConfirmationSupplier,
  toggleMultipleEnquiry,
} from '@bridebook/web/lib/enquiries/actions';
import {
  getEnquiryConfirmationSupplier,
  getShowEnquiryForm,
} from '@bridebook/web/lib/enquiries/selectors';
import { useDispatch, useSelector } from '@bridebook/web/lib/utils';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';
import { IEnquiryConfirmationModal } from './';

const EnquiryConfirmationModal = lazyComponent<IEnquiryConfirmationModal>(
  () => import('@bridebook/web/components/enquiries/enquiry-confirmation-modal'),
);

interface LazyEnquiryConfirmationModalProps {}

const EnquiryConfirmationModalLazy: React.FC<LazyEnquiryConfirmationModalProps> = () => {
  const showEnquiryForm = useSelector(getShowEnquiryForm);
  const dispatch = useDispatch();
  const weddingId = useSelector((state) => state.weddings.profile.id);
  const enquiryConfirmationSupplier = useSelector(getEnquiryConfirmationSupplier);
  const { query } = useRouter();
  const enquirySupplierId = query?.enquirySupplier;

  useEffect(() => {
    if (enquirySupplierId && weddingId) {
      dispatch(fetchEnquiryConfirmationSupplier(enquirySupplierId as string));
    }
    return () => {
      dispatch(toggleMultipleEnquiry(false));
    };
  }, [dispatch, enquirySupplierId, weddingId]);

  const showConfirmationScreen =
    query?.enquiryConfirmation === 'true' &&
    enquiryConfirmationSupplier?.publicId === query?.enquirySupplier;

  if (!showConfirmationScreen && !showEnquiryForm) return null;

  return <EnquiryConfirmationModal showConfirmationScreen={showConfirmationScreen} />;
};

export default memo(EnquiryConfirmationModalLazy);
